const ar = {
  somethingWentWrong: "عذرا، هنالك خطأ ما، الرجاء إعادة المحاولة لاحقا",

  login: "تسجيل الدخول",
  loginId: "معرف الدخول",
  password: "كلمة المرور",

  users: "المستخدمون",
  name: "اسم",
  phoneNumber: "رقم التليفون",
  userId: "معرف المستخدم",
  email: "بريد إلكتروني",
  idNumber: "رقم معرف",
  submit: "يُقدِّم",
  createUser: "إنشاء مستخدم",
  registeredAt: "مسجل فى",
  days: "أيام",
  gym: "جیم",
  swim: "السباحة",

  dailyReport: "تقرير يومي",
  advancedDailyReport: "التقرير اليومي المسبق",
  orders: "طلبات",
  admin: "مسؤل",
  logout: "تسجيل خروج",

  admins: "المشرفون",
  center: "المراكز",
  packages: "الحزم",

  id: "ئایدی",
  createdAt: "أنشئت في",
  type: "يكتب",
  features: "سمات",

  duration: "مدة",
  price: "سعر",
  discount: "تخفيض",
  englishName: "الاسم الانجليزي",
  kurdishName: "الاسم الكردي",
  arabicName: "الاسم العربي",
  showType: "نوع العرض",
  firstTime: "اول مرة",
  afterFirstTime: "بعد أول مرة",
  allTime: "كل الوقت",

  owner: "صاحب",
  manager: "مدير",
  trainer: "مدرب",
  reception: "ريسبشن",

  distributionWithTrainer: "التوزيع مع المدرب",
  notDistributionWithTrainer: "عدم التوزيع مع المدرب",

  divideBenefit: "فائدة القسمة",
  requestCourse: "الکورسات",
  cafeteria: "كافيتريا",
  cafeteriaBenefit: "فوائد الكافتيريا",
  expenses: "مصاريف",
  cafeteriaExpenses: "مصاريف الكافتيريا",
  totalCafeteriaExpenses: 'إجمالي مصاريف الكافتيريا',
  gymExpenses: "مصاريف الجيم",
  date: "تاريخ",

  endDate: "تاريخ الانتهاء",

  supplements: "المكملات",

  newUser: "مستخدم جديد",
  renewSubscription: "تجديد الاشتراك",
  membershipBenefit: "مزايا العضوية",
  reportSummary: "ملخص التقرير",
  advancedReportSummary: "ملخص التقرير المتقدم",
  revenue: "إيرادات",
  profit: "ربح",
  membershipSummary: "ملخص العضوية",
  financeSummary: "ملخص التمويل",
  main: "رئيسي",

  numberOrder: "رقم الطلب.",
  dashboard: "داشبورد",

  memberships: "العضويات",
  activeUser: "مستخدم نشط",
  expiredUser: "مستخدم منتهي الصلاحية",
  startDate: "تاريخ البدء",
  start: "يبدأ",
  end: "نهاية",
  day: "يوم",
  username: "اسم المستخدم",
  ticketNumber: "رقم التذكرة",

  offerType: "نوع العرض",
  receptionDivideBenefit: "مبلغ التوزيع مع الإيصال",
  receptionDivideBenefitIQD: "مبلغ التوزيع مع الإيصال بالدينار",
  normal: "طبيعي",
  offer: "يعرض",

  delete: "يمسح",

  undefined: "غير معرف",
  male: "ذكر",
  female: "أنثى",
  gender: "جنس",

  openingTheDoors: "فتح الأبواب",
  door: "باب",
  reason: "سبب",
  employeeComing: "موظف قادم",

  wholesalePrice: "سعر بالجملة",
  minimumSalePrice: "الحد الأدنى لسعر البيع",
  buyPrice: "سعر شراء",

  balance: "الرصيد",

  numberOfGuestUsers: "عدد المستخدمين الضيوف",
  sellPrice: "سعر البيع",
  realPrice: "السعر الحقيقي",

  numberOfProductInStore: "عدد المنتجات في المخزون",

  buy: "يشتري",
  returnOfPurchase: "عودة الشراء",
  image: "صورة",
  select: "يختار",
  sellId: "ئایدی البيع",
  note: "ملحوظة",
  customers: "عملاء",
  debt: "قرض",
  repaymentOfDebt: "سداد الديون",
  sell: "يبيع",
  freeWallet: "محفظة مجانية",
  money: "الفلوس",
  payedPrice: "السعر المدفوع",
  totalPrice: "السعر الكلي",
  productNumber: "رقم المنتج",
  totalPreviousDebts: "إجمالي الديون السابقة",
  totalDebts: "إجمالي الديون",
  quantity: "العدد",
  qty: 'عدد',
  print: "مطبعة",
  equipments: "تجهيزات",
  shippingCars: "شحن سيارات",
  brands: "الماركات",
  totalPayedPrice: "إجمالي السعر المدفوع",
  remainingDebts: "الديون المتبقية",
  brand: "ماركة",
  code: "کود",
  salary: "راتب",
  stock: "مخزون",
  cleaner: "منظف",
  accountant: "محاسب",
  proteinSeller: "بائع البروتين",
  socialMedia: "سوشیال میدیا",
  technical: "تکنیکال",
  expense: "مصروف",
  cafeteriaGuestUser: "مستخدم ضيف الكافتيريا",
  totalSalary: "كامل الراتب",
  garage: "کراج",
  supplementExpenses: "مصاريف المكملات",
  bigExpenses: "مصاريف كبيرة",
  package: "پاکیج",
  insertLogoToImage: "أدخل الشعار إلى الصورة",
  proteinManager: "مدير البروتين",
  equipmentManager: "مدير الجهازات",
  stockBenefitPrice: "قازانجی کۆگا (نرخی تاک)",
  stockBenefitWholePrice: "قازانجی کۆگا (نرخی کۆ)",
  stockBenefitBuyPrice: "کۆی کۆگا (نرخی کڕین)",

  benefitPrice: "قازانج (نرخی تاک)",
  BenefitWholePrice: "قازانج (نرخی کۆ)",

  live: "مباشر",
  purchasesHistory: "تاريخ المشتريات",
  balancesHistory: "تاريخ الرصید",
  usersFeedback: "التقيمات",
  starRate: "النجوم",
  feedback: "تعليق",
  newSubscribers: "المشتركون الجدد",
  renewalOfSubscriptions: "تجديد الاشتراكات",
  dollarPrice: "سعر الدولار",
  proteinStock: 'مخزون البروتين',
  receiptsOfPayment: "إيصالات الدفع",
  retailPrice: 'سعر التجزئة',
  subs: 'الغواصات',
  subject: 'موضوع',
  part: 'جزء',
  recipients: 'المستلمون',
  receipts: 'الإيصالات',
  customs: 'جمارك',
  carNumber: 'رقم السياره',
  cost: 'يكلف',
  expense_1: 'مصروف',
  creatingTransition: 'إنشاء انتقال',
  centers: 'مراكز',
  administration: 'إدارة',
  brandImage: 'صورة الماركة',
  categories: 'فئات',
  jobOpportunities: 'فرص عمل',
  cvs: 'السير الذاتية',
  location: 'موقع',
  position: 'موقع',
  revenueByBenefitPrice: 'الإيرادات حسب (سعر البيع - سعر الشراء)',
  revenueByItems: 'الإيرادات حسب المنتج المباع',
  revenueByBuyPrice: 'الإيرادات حسب المنتج المباع',
  profitWithoutExpenses: 'الإيرادات حسب المنتج المباع',
  publicDebt: 'قرض عام',
  ratio: 'نسبە',
  profitAtRetailPrice: 'الربح بسعر التجزئة',
  profitAtWholeSalePrice: 'الربح بسعر الجملة',
  gymReception: 'جیم ریسیپشن',
  cafeteriaReception: 'کافتیریا ریسیپشن',
  gymCoach: 'مدرب جیم',
  monthlyReport: 'تقرير شهري',
  normalCourseProfit: 'ربح کورس العادية',
  VIPCourseProfit: 'ربح کورس VIP',
  cafeteriaProfit: 'ربح كافتيريا',
  publicProfitAfterMamAzad: 'الربح العام بعد مام ازاد',
  publicProfit: 'الربح العام',
  coursesReport: 'تقرير الکورسات',
  save: 'يحفظ',
  loading: 'تحميل',
  equipmentStock: 'مخزون الاجهزه',
  licenses: 'التراخيص',
  'attendance-time': 'وقت الحضور',
  childrenNannies: 'مربيات الأطفال',
  accountantOfAnotherCompany: 'محاسب شركة أخرى',
  asudaCity: 'اسودا ستی',
  'asudaCity$': 'اسودا ستی $',
  paroshTowers: 'پروش تاورز',
  'paroshTowers$': 'پروش تاورز $',
  slavaCity: 'سلافا ستی',
  'slavaCity$': 'سلافا ستی $',
  mamAzad: 'مام ازاد',
  'mamAzad$': 'مام ازاد $',
  miniSlavaMen: 'مینیسلافا رجال',
  'miniSlavaMen$': 'مینیسلافا رجال $',
  miniSlavaWomen: 'مینیسلافا نساء',
  'miniSlavaWomen$': 'مینیسلافا نساء $',
  lifeTowers: 'لایف تاورز',
  'lifeTowers$': 'لایف تاورز $',
  akaFitnessProfit: 'ئاکا فتنس ربح',
  akaFitnessProfit$: 'ئاکا فتنس ربح $',
  finalProfit: 'الربح النهائي',
  'price-lists': 'قائمة الأسعار',
  'select-item': 'حدد البند',
  cancel: 'ألغ',
  repaymentOfDebtAkaPower: 'سداد القرض (AkaPower)',
  debtsAkaPower: 'قروض (AkaPower)',
  swimmingItems: 'عناصر السباحة',
  akaFitnessSupplementsProfit: 'ئاکا فتنس ربح المكملات',
  asudaSupplementsProfit: 'اسودا ربح المكملات',
  finalPrice: 'السعر النهائي',
  totalRepaymentOfDebt: 'إجمالي سداد القرض',
  totalPayedPriceFromSells: 'إجمالي السعر المدفوع من عمليات البيع',
  'revenue(repaymentOfDebt,payedPrice)': 'الإيرادات (سداد القرض ، السعر المدفوع)',
  ratioByDebt: 'النسبة حسب القرض',
  ratioBySupplement: 'النسبة حسب المكملات',
  ratioByMoney: 'النسبة حسب الرصيد',
  ratioType: 'نوع النسبة',

  gyms: 'الجيمات',

  currentMonth: 'الشهر الحالي',
  lastMonthByThisTime: 'الشهر الماضي في هذا الوقت',
  lastMonth: 'الشهر الماضي',
  allOfThem: 'كل منهم 💥',
  trainers: 'المدربون',
  thereIsNoDataToDisplay: 'لا توجد بيانات لعرضها',
  sellSupplements: 'بيع المكملات',
  deleteMembership: 'حذف العضوية',

  'areYouSureYouWantToDeleteThisExpense?': 'هل أنت متأكد أنك تريد حذف هذه النفقات؟',
  deletionOfExpenses: 'شطب المصاريف',
  'areYouSureAboutDeleting?': 'هل أنت متأكد من الحذف؟',
  totalPriceOfRegularCourses: 'السعر الإجمالي للکورسات العادية',
  'totalPriceOfVIPCourses': 'السعر الإجمالي لکورسات VIP',
  numOfNormalCourses: 'عدد کورسات العادية',
  numOfVIPCourses: 'عدد کورسات VIP',
  'trainerProfitsFromRegularCourses': 'أرباح المدرب من الکورسات العادية',
  'trainerProfitsFromVIPCourses': 'أرباح المدرب من کورسات VIP',
  akaFitnessProfitFromRegularCourses: 'ئاکا فتنس ربح من الکورسات العادية',
  'akaFitnessProfitsFromVIPCourses': 'ئاکا فتنس ربح من کورسات VIP',
  coachGrossProfit: 'الربح الإجمالي للمدرب',
  grossProfitAkaFitness: 'الربح الإجمالي لئاکا فتنس',
  num: 'رقم.',
  nameOfTheEmployee: 'اسم الموظف',
  fixedSalary: 'راتب ثابت',
  courseRatio: 'نسبة الکورس',
  supplementRatio: 'نسبة المكملات',
  numOfSupplements: 'عدد المكملات',
  totalPriceOfSupplements: 'السعر الإجمالي للمكملات',
  'trainerProfit15%': 'أرباح المدرب 15%',
  theDollarIsGenerallyCalculatedAt: 'يتم حساب الدولار بشكل عام في',
  courseReportSummary: 'ملخص تقرير الکورسات',
  salariesOfEmployees: 'رواتب الموظفين {{price}}',
  summaryOfTheDietarySupplementReport: 'ملخص تقرير المكملات الغذائية',
  cafeteriaSalesReportSummary: 'ملخص تقرير مبيعات الكافتيريا',
  totalOfProductsWereSoldAtPriceOfDinars: 'تم بيع إجمالي {{qty}} منتجًا بالسعر {{price}} دینار',
  salaryNotSpecified: 'الراتب غير محدد',
  dateNotSpecified: 'التاريخ غير محدد',
  salaryByDate: 'الراتب حسب التاريخ',

  increasedExpenses: 'زيادة المصاريف',
  updateOfExpenses: 'تحديث المصاريف',
  byPrice: 'بالسعر',

  courseWriting: 'كتابة الکورس',
  courseUpdate: 'تحديث الکورس',
  changeOfParticipation: 'تغيير المشاركة',

  sellingOfSupplements: 'بيع المكملات',
  updateOfSellingSupplements: 'تحديث بيع المكملات',
  purchaseBalance: 'رصيد الشراء',
  changeOfBalance: 'تغيير الرصيد',
  openingTheDoor: 'فتح الأبواب',
  becauseOf: 'بسبب',
  saleOfCafeteriaProducts: 'بيع منتجات الكافتيريا',

  star: 'نجمة',
  in: 'في',
  for: 'ل',
  total: 'مجموع',
  search: 'بحث',

  numOfMemberships: 'عدد العضويات',
  numOfThreeMonth: 'عدد العضويات لمدة ثلاثة اشهر',
  numOfSixMonth: 'عدد العضويات ستة اشهر',
  totalPriceOfThreeMonths: 'السعر الإجمالي لثلاثة أشهر',
  totalPriceOfSixMonths: 'السعر الإجمالي لستة أشهر',
  receptionRatioOfThreeMonths: 'نسبة الاستقبال لمدة ثلاثة أشهر',
  receptionRatioOfSixMonths: 'نسبة الاستقبال لمدة ستة أشهر',
  akaFitnessDivideBenefitIQD: 'ئاکا فتنس تقسيم الفائدة IQD',

  receptionReportSummary: 'ملخص تقرير الاستقبال',
  receptionsRatio: 'نسبة الاستقبال',
  'thereWere{{update}}UpdatesAnd{{new}}NewSubscribersInTheReportGenerated': 'كان هناك {{new}} وتحديثًا وتم إنشاء {{update}} مشتركًا جديدًا في التقرير',
  membershipsRatio: 'نسبة العضوية',

  cafeExpense: 'مصاريف الكافتيريا',
  gymExpense: 'مصاريف الجيم',
  bigExpense: 'مصاريف كبيرة',
  by: 'بقرب',
  writeDownTheReasonForOpeningTheDoor: 'اكتب سبب فتح الباب',
  open: 'فتح',
  numOfDay: 'یوم {{num}}',
  'areYouSureAboutExecutingTheAction': 'هل أنت متأكد من تنفيذ الإجراء؟',
  youCannotChangeProducts: 'لا يمكنك تغيير المنتجات',
  youCannotChangeProducts1: 'لا يمكنك تغيير المنتج إذا قمت بإدخاله بشكل غير صحيح. الرجاء إعادة المنتج ثم تسجيل منتج جديد',
  player: 'لاعب',
  returnSupplementsProductToMainStorage: 'إرجاع منتجات المكملات إلى التخزين الرئيسي',
  others: 'آحرون',
  playersFromOtherHalls: 'لاعبون من قاعات أخرى',
  dollar: 'دولار',
  iqd: 'دينار',
  renew: 'تجديد',
  userNotFoundPleaseVerifyID: 'لم يتم العثور على المستخدم الرجاء التحقق من ئایدی',
  noUser: 'لا يوجد مستخدم',
  printLastMembership: 'طباعة آخر اشتراک',
  addBalance: 'إضافة رصيد',
  updateFaceId: 'تحديث فیس ئایدی',
  updateCurrentPackage: 'تحديث الحزمة الحالية',
  advancePurchase: 'شراء مسبق',
  resetMobileAccount: 'إعادة تعيين حساب الموبايل',
  doYouWantToRegisterFace: 'هل تريد تسجيل فیس ئایدی؟',
  sendRequest: 'إرسال طلب',
  deleteTheLastSubscriptionAndExpireIt: 'حذف الاشتراك الأخير وتنتهي صلاحيته',
  problemsWithTheParticipantsBalance: 'مشاكل مع رصيد المشارك',
  problemsWithFaceRecognition: 'مشاكل مع التعرف على الوجه',
  lastSubscriptionNotIncludedInDailyReport: 'آخر اشتراك غير مدرج في التقرير اليومي',
  problemsWithMobileAccounts: 'مشاكل مع حسابات الموبايل',
  suggestedRequest: 'طلب مقترح',
  orCustomRequest: 'أو طلب مخصص',
  moreDetails: 'مزيد من التفاصيل',
  request: 'طلب',
  orSuggestedRequest: 'أو طلب مقترح',
  theSameMemberHasMultipleAccounts: 'نفس العضو لديه حسابات متعددة',
  transferOfParticipation: 'نقل المشاركة',
  send: 'إرسال',
  changeTrainerName: 'تغيير اسم المدرب',
  changeCoursePrice: 'تغيير سعر الکورس',
  deleteCourse: 'حذف الکورس',
  deleteExpense: 'حذف المصرف',
  changeSupplementPrice: 'تغيير سعر المكملات',
  revenueType: 'نوع الإيرادات',
  vipLocker: 'لوکر VIP',
  salon: 'صالون',
  deleteRevenue: 'حذف الإيرادات',
  otherRevenue: 'إيرادات أخرى',
  timesLeft: 'المرات المتبقية',
  openDoor: 'فتح الباب',
  returnSupplement: 'إرجاع المكملات',
  'areYouSureYouWantToResetYourMobileAccount?': 'هل أنت متأكد من إعادة تعيين حساب الموبايل؟',
  'areYouSureYouWantUpdateFaceID?': 'هل أنت متأكد من تحديث فیس ئایدی؟',
  'areYouSureYouWantOpenDoor?': 'هل أنت متأكد من فتح الباب؟',
  requests: 'طلبات',
  pendingRequests: 'طلبات معلقة',
  status: 'حالة',
  pending: 'معلق',
  accepted: 'مقبول',
  rejected: 'مرفوض',
  cash: 'نقد',
  makeItFree: '! 😕 اجعلها مجانية',
  free: 'مجانا',
  requestedCourse: 'الکورس المطلوب',
  captain: 'كابتن',
  updateFaceIdOf: 'تحديث فیس ئایدی ل',
  "Gym Door": "باب الجيم",
  "Main Door": "باب رئيسي",
  "Swim Door": "باب السباحة",
  lastMembership: 'آخر اشتراک',
  addSwimmingItem: 'إضافة عنصر سباحة',
  systemStatusNormal: 'حالة سیستم طبيعية',
  systemStatus: 'حالة سیستم',
  akaPowerMainServer: 'ئاکا پاور سرفر رئيسي',
  faceRecognitionMachine: 'جهاز التعرف على الوجه',
  abnormal: 'غير طبيعي',
  cafeCard: 'کارت کافتیریا',
  userNotSaveInFaceMachinePleaseTryAgain: 'لم يتم حفظ المستخدم في جهاز التعرف على الوجه، الرجاء المحاولة مرة أخرى',
  payedType: 'نوع الدفع',
  payedTypeMessage: 'يرجى سؤال العميل إذا كان يدفع بالدولار أو الدينار؟',
  coach: 'مدرب',
  profile: 'الملف الشخصي',
  totalMoneyReceived: 'إجمالي المال المستلم',
  totalAvailableMoney: 'إجمالي المال المتاح',
  reportSummaryNew: 'ملخص التقرير (جديد)',
  amountOfPaymentByCustomer: 'مبلغ الدفع من العميل',
  "physicalTherapy": "العلاج الطبيعي",
  aFullHourPhysicalTherapySessionForPartBody: "جلسة علاج طبيعي لمدة ساعة كاملة لجزء من الجسم",
  fullBodyMessageOneHour: "جلسة كاملة للجسم لمدة ساعة",
  fourPhysicalTherapy: "أربع جلسات علاج طبيعي",
  addPhysicalTherapy: "إضافة علاج طبيعي",
  userName: "اسم المستخدم",
  update: "تحديث",
  "expiryDate": "تاريخ انتهاء الصلاحية",
  "lastMembershipDate": "تاريخ العضوية الأخير",
  birthDate: "تاريخ الميلاد",
  receipt: "إيصال",
  available: "متاح",
  usd: "دولار",
  dinar: "دينار",
  swimmingSales: "مبيعات السباحة",
  nutritionSales: "مبيعات التغذية",
  nutrition: "التغذية",
  cafeteriaCash: "نقد الكافتيريا",
  "cafeteria-card": "کارت کافتیریا",
  discountForEmployees15: "تخفيض 15% للموظفين",

};


export default ar